import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { setWTRegion, setDivision, setLang, setLeverage, setFP } from '../../actions/params'
import { loadData } from '../../actions/data'
import { getwtRegion, getDivision, getLang, getFP, getLeverage, getIsEU } from '../../reducers/params'
import { getInitialLoad } from '../../reducers/data'
import DetailsTable from './DetailsTable/DetailsTable'
import Filters from './Filters/Filters'
import i18n from '../../i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import './App.css'
import { getAsOfDate, getActivePane } from '../../reducers/data'
library.add(faCircleNotch)
class App extends PureComponent {
  componentWillMount() {
    this.props.loadData()
  }
  setRegion(param) {
    this.props.setWTRegion(param)
  }

  setDivision(param) {
    this.props.setDivision(param)
  }

  setLang(param) {
    this.props.setLang(param)
  }

  render() {
    console.log('initial Load', this.props.initialLoad)
    if (this.props.initialLoad === false) {
      return (
        <div colSpan='12' style={{ textAlign: 'center' }}>
          <FontAwesomeIcon icon='circle-notch' size='3x' style={{ color: '#05a9b1', marginTop: '45px' }} spin />
        </div>
      )
    } else
      return (
        <div className='app'>
          <Filters wtregion={this.props.wtregion} division={this.props.division} lang={this.props.lang} isLeveraged={this.props.isLeveraged} isFP={this.props.isFP} isEU={this.props.isEU} asOf={this.props.asOfDate} />
          <DetailsTable wtregion={this.props.wtregion} division={this.props.division} lang={this.props.lang} isLeveraged={this.props.isLeveraged} isFP={this.props.isFP} isEU={this.props.isEU} asOf={this.props.asOfDate} />
          <div className='yield'>{i18n.t('ttmyield')}</div>
        </div>
      )
  }
}

function mapStateToProps(state) {
  return {
    wtregion: getwtRegion(state),
    division: getDivision(state),
    lang: getLang(state),
    isLeveraged: getLeverage(state),
    isFP: getFP(state),
    isEU: getIsEU(state),
    asOfDate: getAsOfDate(state),
    activePane: getActivePane(state),
    initialLoad: getInitialLoad(state)
  }
}

export default connect(mapStateToProps, {
  loadData,
  setWTRegion,
  setDivision,
  setLang,
  setLeverage,
  setFP
})(App)



// WEBPACK FOOTER //
// ./src/components/App/App.js